import axios from "axios";
import Cookies from "js-cookie";
import { apiRoutesForContext } from "src/routes/apiRoutes/react-api-route-paths";
import { PaginationRequest } from "src/sdk";
import { Feedback, Ticket } from "src/sdk/models/Ticket";
import { BaseService } from "../services/BaseService";

const tmp = apiRoutesForContext();
export class TicketService extends BaseService {
    public authRoutes: typeof tmp;

    constructor() {
        super();
        this.authRoutes = apiRoutesForContext();
    }

    getTickets(data: PaginationRequest): Promise<any> {
        var token = Cookies.get("JwtToken");
        //"&filemakerUUID=" + data.filemakerUUID + 
        let url = "?pageSize=" + data.pageSize + "&page=" + data.page + "&search=" + data.search + "&sortBy=" + data.sortBy + "&sortOrder=" + data.sortOrder;
        if (data.filemakerUUID)
            url += "&filemakerUUID=" + data.filemakerUUID;
        return axios({
            method: "get",
            baseURL: this.routes.server.root(),
            headers: { "Content-Type": "application/json", "Authorization": `Bearer ${token}` },
            url: this.routes.ticket().getTickets() + url,
        })
    }


    getTicketsByOrganisation(data: PaginationRequest): Promise<any> {
        var token = Cookies.get("JwtToken");
        return axios({
            method: "get",
            baseURL: this.routes.server.root(),
            headers: { "Content-Type": "application/json", "Authorization": `Bearer ${token}` },
            url: this.routes.ticket().getTicketsByOrganisation() + "?fielmakerUUID=" + data.filemakerUUID + "?pageSize=" + data.pageSize + "&page=" + data.page + "&search=" + data.search + "&sortBy=" + data.sortBy + "&sortOrder=" + data.sortOrder,
        })
    }

    getTicketById(id: number): Promise<any> {
        var token = Cookies.get("JwtToken");
        return axios({
            method: "get",
            baseURL: this.routes.server.root(),
            headers: { "Content-Type": "application/json", "Authorization": `Bearer ${token}` },
            url: this.routes.ticket().getTickets() + "/" + id,
        })
    }

    createTicket(data: Ticket): Promise<any> {
        var token = Cookies.get("JwtToken");
        return axios({
            method: "post",
            baseURL: this.routes.server.root(),
            headers: { "Content-Type": "application/json", "Authorization": `Bearer ${token}` },
            url: this.routes.ticket().createTicket(),
            data: data
        })
    }

    deleteTicket(id: number): Promise<any> {
        var token = Cookies.get("JwtToken");
        return axios({
            method: "delete",
            baseURL: this.routes.server.root(),
            headers: { "Content-Type": "application/json", "Authorization": `Bearer ${token}` },
            url: this.routes.ticket().deleteTicket() + "/" + id,
        })
    }

    createFeedback(data: Feedback): Promise<any> {
        var token = Cookies.get("JwtToken");
        return axios({
            method: "post",
            baseURL: this.routes.server.root(),
            headers: { "Content-Type": "application/json", "Authorization": `Bearer ${token}` },
            url: this.routes.ticket().createFeedback(),
            data: data
        })
    }

    getTicketByTicketId(ticketId: string): Promise<any> {
        var token = Cookies.get("JwtToken");
        return axios({
            method: "get",
            baseURL: this.routes.server.root(),
            headers: { "Content-Type": "application/json", "Authorization": `Bearer ${token}` },
            url: this.routes.ticket().getTicketByTicketId() + "/" + ticketId,
        })
    }

    getFieldSettingsHeader(id: string): Promise<any> {
        var token = Cookies.get("JwtToken");
        return axios({
            method: "get",
            baseURL: this.routes.server.root(),
            headers: { "Content-Type": "application/json", "Authorization": `Bearer ${token}` },
            url: this.routes.ticket().getFieldSettingsHeader() + "/" + id,
        })
    }

    /* createFileByTicketId(data: TicketsFile): Promise<any> {
        var token = Cookies.get("JwtToken");
        return axios({
            method: "post",
            baseURL: this.routes.server.root(),
            headers: {  "Authorization": `Bearer ${token}` },
            url: this.routes.ticket().createFileByTicketId(),
            data: data
        })
    } */


    createFileByTicketId(ticketId: number, file: File): Promise<any> {
        const token = Cookies.get("JwtToken");

        const formData = new FormData();
        formData.append("File", file); // Prilagođeni naziv polja "File"
        formData.append("TicketId", ticketId.toString()); // Prilagođeni naziv polja "File"

        return axios({
            method: "post",  // POST metod
            baseURL: this.routes.server.root(),

            url: this.routes.ticket().createFileByTicketId(),
            headers: {
                "Authorization": `Bearer ${token}`,
            },
            data: formData,  // Tijelo request-a sa FormData
        });
    }




}
